import { getAvatarBackground } from "@/utils/get-avatar-background";

export const getInitialsAvatar = (name: string, surname: string) => {
  const getInitials = (name: string, surname: string) => {
    return name.slice(0, 1) + surname.slice(0, 1);
  };

  let initials = "";

  if (surname) {
    initials = getInitials(name, surname);
  } else {
    const splittedName = name.split(" ");
    initials =
      splittedName.length === 1
        ? splittedName[0].slice(0, 1)
        : getInitials(splittedName[0], splittedName[1]);
  }

  return { initials, avatarColor: getAvatarBackground(name) };
};
